import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class TreeAncient1PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.TREE_ANCIENT1;
}

export default TreeAncient1PoiTileEntity;
